module.exports = __webpack_public_path__ + "static/media/SocixProject.c4f58270.png";